// extracted by mini-css-extract-plugin
export var episode_details = "posts-detail-module--episode_details--fd142";
export var podcast_details = "posts-detail-module--podcast_details--968c1";
export var podcast_details_container = "posts-detail-module--podcast_details_container--1baec";